 $(window).scroll(function() {

     var scroll = $(window).scrollTop();
     if (scroll >= 550) {
         $("header").addClass("fixed-top");
     } else {
         $("header").removeClass("fixed-top");
     }

     if (scroll >= 500) {
         $(".db-fullvodeo-outer").removeClass("show");
     } else {
         $(".db-fullvodeo-outer").addClass("show");
     }

     if (scroll >= 500) {
         $("body").addClass("hide-video");
     } else {
         $("body").removeClass("hide-video");
     }

     // End Video Scroll Function

 });

 //  $(function() {
 //      new WOW().init();
 //  });